import dynamic from 'next/dynamic';
import type { Step } from '../flows';

export const nu: Step[] = [
  {
    step: 'how-fixes-work',
    gutter: 'none',
    screenViewEvent: { name: 'styled_for' },
    Component: dynamic(
      () =>
        import('../../HowFixesWork/HowFixesWork').then(
          module => module.HowFixesWork,
        ),
      { ssr: false },
    ),
  },
  {
    step: 'schedule',
    screenViewEvent: { name: 'fix_frequency' },
    gutter: 'narrow',
    Component: dynamic(
      () => import('../../Schedule/Schedule').then(module => module.Schedule),
      { ssr: false },
    ),
  },
  {
    step: 'reservation',
    screenViewEvent: { name: 'fix_date' },
    gutter: 'narrow',
    Component: dynamic(
      () =>
        import('../../Reservation/Reservation').then(
          module => module.Reservation,
        ),
      { ssr: false },
    ),
  },
  {
    step: 'payment',
    screenViewEvent: { name: 'consolidated_shipping_payment' },
    gutter: 'narrow',
    Component: dynamic(
      () =>
        import(
          '../../ShippingPaymentConsolidated/ShippingPaymentConsolidated'
        ).then(module => module.ShippingPaymentConsolidated),
      { ssr: false },
    ),
    showNavTitle: true,
  },
  {
    step: 'finalize',
    screenViewEvent: { name: 'confirm_first_fix' },
    Component: dynamic(
      () => import('../../Finalize/Finalize').then(module => module.Finalize),
      { ssr: false },
    ),
    hideNav: true,
    bgColor: 'mint',
    navBgColor: 'mint',
  },
];
